import React from 'react';
import { motion } from 'framer-motion';
export function EmpathySection() {
  const paragraphs = ['La tarde cae. La casa se queda en silencio. Y algo adentro se aprieta.', 'No es tristeza con nombre. Es esa sensación de que ya no te toca a nadie.', 'De que el mundo sigue girando... pero tú te quedaste quieta.', 'Y lo peor: no se lo puedes decir a nadie. Porque tú no eres de las que dan lástima.'];
  return <section className="py-24 md:py-32 px-6 bg-[#1a1714]" data-id="element-18">
      <div className="max-w-3xl mx-auto text-center" data-id="element-19">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="text-2xl md:text-3xl font-serif text-[#d4a574] mb-16 italic" data-id="element-20">
          Sabes exactamente cuándo empieza.
        </motion.h2>

        <div className="space-y-12" data-id="element-21">
          {paragraphs.map((text, index) => <motion.p key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 1,
          delay: index * 0.3,
          ease: 'easeOut'
        }} className="text-xl md:text-2xl text-[#f5efe6]/90 font-light leading-relaxed" data-id="element-22">
              {text}
            </motion.p>)}
        </div>

        <motion.div initial={{
        scaleX: 0,
        opacity: 0
      }} whileInView={{
        scaleX: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.5,
        delay: 1.5
      }} className="h-px w-32 bg-gradient-to-r from-transparent via-[#d4a574]/50 to-transparent mx-auto mt-24" data-id="element-23" />
      </div>
    </section>;
}